import { types } from 'mobx-state-tree';

export default types.model('PurchaseToken', {
  alias: types.string,
  buyer: types.string,
  payment_method: types.string,
  price: types.number,
  title: types.string,
});
